import React from 'react';
import { CSpinner } from '@coreui/react';
import styles from './LoadingOverlay.module.css';

const LoadingOverlay = ({ message = 'Cargando...', isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.content}>
        <CSpinner color="primary" variant="grow" />
        <p className={styles.message}>{message}</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;